//import utils from '@/common/utils.js';

export default {
  async initDataGrid() {
    const me = this;
    const dataGrid = this.$refs.dataGrid;
    if (dataGrid) {
      dataGrid.gridOptions.suppressPropertyNamesCheck = true;
      dataGrid.gridOptions.undoRedoCellEditing = true;
    }

    let columnInfoMap = {};
    this.columnSettings.columnInfos.forEach((element) => {
      columnInfoMap[element.ColumnName] = element;
    });

    me.initCssClassRules();
    me.defaultColumnDefs = {
      editable: true,
      resizable: true,
    };
    me.columnDefs = me.createHeaderColumnDefs(columnInfoMap);
    me.columnDefs.push(...me.createValueColumnDefs(columnInfoMap));
    me.columnDefs.push(me.createTotalColumnDef(columnInfoMap));
  },

  getColumnInfoValue(map, columnName, propertyName, defaultValue) {
    let info = map[columnName];
    if (info == null || info[propertyName == null]) {
      return defaultValue;
    } else {
      return map[columnName][propertyName];
    }
  },

  createValueColumnDef(weekday, weekdayNo, columnInfoMap) {
    const me = this;
    const columnName = `Column_WorkHours${weekday}`;
    return {
      field: `${weekday}Value`,
      columnName: columnName,
      headerName: me.$t(columnName),
      isValueColumn: true,
      weekdayNo: weekdayNo,
      editable: (params) =>
        me.isUserInTeam(me.selectedUserUID) &&
        me.isDayEditable(params, weekdayNo),
      minWidth: 70,
      maxWidth: 110,
      width: me.getColumnInfoValue(columnInfoMap, columnName, "width", 80),
      hide: !me.getColumnInfoValue(columnInfoMap, columnName, "visible", true),
      resizable: true,
      cellEditor: "WorkOrExpenseEditor",
      type: "rightAligned",
      cellClassRules: me.valueCellClassRules,
      cellRenderer: "valueRenderer",
      valueFormatter: (params) => {
        return this.formatWorkOrExpenses(params);
      },
    };
  },

  createValueColumnDefs(columnInfoMap) {
    const me = this;
    const valueColumnDefs = [
      me.createValueColumnDef("Monday", 0, columnInfoMap),
      me.createValueColumnDef("Tuesday", 1, columnInfoMap),
      me.createValueColumnDef("Wednesday", 2, columnInfoMap),
      me.createValueColumnDef("Thursday", 3, columnInfoMap),
      me.createValueColumnDef("Friday", 4, columnInfoMap),
      me.createValueColumnDef("Saturday", 5, columnInfoMap),
      me.createValueColumnDef("Sunday", 6, columnInfoMap),
    ];
    return valueColumnDefs;
  },

  createHeaderColumnDefs(columnInfoMap) {
    const me = this;
    const headerColumnDefs = [
      {
        field: "WorkTypeDisplayField",
        columnName: "Column_WorkTypeID",
        isHeaderColumn: true,
        headerName: me.$t("Column_WorkTypeID"),
        editable: false,
        resizable: true,
        hide: !me.getColumnInfoValue(
          columnInfoMap,
          "Column_WorkTypeID",
          "visible",
          true
        ),
        width: me.getColumnInfoValue(
          columnInfoMap,
          "Column_WorkTypeID",
          "width",
          160
        ),
        cellClassRules: me.cellClassRules,
        cellRendererSelector: me.getDefaultRenderer,
      },
      {
        field: "CostCenterIDAndDescription",
        columnName: "Column_CostCenter",
        headerName: me.$t("Column_CostCenter"),
        isHeaderColumn: true,
        editable: (params) =>
          me.isHeaderColumnEditable(params) && me.isWeekEditable(params),
        cellClassRules: me.cellClassRules,
        hide: !me.getColumnInfoValue(
          columnInfoMap,
          "Column_CostCenter",
          "visible",
          false
        ),
        width: me.getColumnInfoValue(
          columnInfoMap,
          "Column_CostCenter",
          "width",
          130
        ),
        cellEditor: "LookupEditor",
        cellEditorParams: {
          caption: me.$t("SelectCostCenter"),
          apiUrl: "CostCenters",
          columnDefs: [
            {
              field: "CostCenterID",
              headerName: me.$t("CostCenterID"),
              editable: false,
              resizable: true,
              width: 150,
            },
            {
              field: "CostCenterDescription",
              headerName: me.$t("CostCenterDescription"),
              editable: false,
              resizable: true,
              width: 300,
            },
          ],
          displayFormatDelegate: (data) => {
            return `${data.CostCenterID} - ${data.CostCenterDescription}`;
          },
          keyField: "CostCenterID",
          displayField: "CostCenter",
          searchExactField: "CostCenterID",
        },
        resizable: true,
        valueFormatter: (params) => {
          if (params.node.rowPinned) return params.value; //Possible total caption
          if (params.value) {
            const obj = JSON.parse(params.value);
            return obj.CostCenter;
          }
          return "";
        },
        cellRendererSelector: me.getDefaultRenderer,
      },
      {
        field: "WorkCategory",
        columnName: "Column_WorkCategory",
        headerName: me.$t("Column_WorkCategory"),
        isHeaderColumn: true,
        editable: false,
        cellClassRules: me.cellClassRules,
        width: me.getColumnInfoValue(
          columnInfoMap,
          "Column_WorkCategory",
          "width",
          130
        ),
        hide: !me.getColumnInfoValue(
          columnInfoMap,
          "Column_WorkCategory",
          "visible",
          false
        ),
        resizable: true,
        cellRenderer: "readOnlyRenderer",
      },
      {
        field: "BookingText",
        columnName: "Column_BookingText",
        headerName: me.$t("Column_BookingText"),
        isHeaderColumn: true,
        editable: (params) =>
          me.isUserInTeam(me.selectedUserUID) &&
          me.isHeaderColumnEditable(params) &&
          me.isWeekEditable(params),
        cellClassRules: me.cellClassRules,
        minWidth: 180,
        maxWidth: 500,
        width: me.getColumnInfoValue(
          columnInfoMap,
          "Column_BookingText",
          "width",
          240
        ),
        hide: !me.getColumnInfoValue(
          columnInfoMap,
          "Column_BookingText",
          "visible",
          true
        ),
        resizable: true,
        cellEditor: "MultilineEditor",
        cellEditorParams: {
          caption: me.$t("Column_BookingText"),
        },
        cellRendererSelector: function(params) {
          if (params.node.rowPinned) {
            return {
              component: "boldRenderer",
            };
          } else {
            // rows that are not pinned don't use any cell renderer
            return undefined;
          }
        },
      },
    ];
    return headerColumnDefs;
  },

  createTotalColumnDef(columnInfoMap) {
    const me = this;
    const totalValue = {
      field: "TotalsValue",
      columnName: "Column_WorkHoursTotal",
      headerName: me.$t("Column_WorkHoursTotal"),
      editable: false,
      isTotalColumn: true,
      width: me.getColumnInfoValue(
        columnInfoMap,
        "Column_WorkHoursTotal",
        "width",
        100
      ),
      hide: !me.getColumnInfoValue(
        columnInfoMap,
        "Column_WorkHoursTotal",
        "visible",
        true
      ),
      resizable: true,
      type: "rightAligned",
      cellClassRules: me.cellClassRules,
      valueFormatter: (params) => {
        return this.formatWorkOrExpenses(params);
      },
      cellRenderer: "formattedBoldRenderer",
    };
    return totalValue;
  },
};
